export const BUSINESS_DOMAIN_LOAD = 'BUSINESS_DOMAIN_LOAD'
